import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./pages/app";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Auth from "./pages/auth";
import Error from "./components/Error";
import Test from "./pages/test";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route Component={App} path="/" />
        <Route Component={Auth} path="/auth/:course/:enroll" />
        <Route path="*" Component={Error} />
        <Route path="/test" Component={Test} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
